import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

function ContextualMenu(props) {
  const [options, setOptions] = useState(props.options);
  const [customActions, setCustomActions] = useState(props.customActions);
  const [clickPosition, setClickPosition] = useState(props.clickPosition);
  const [id, setId] = useState(props.id);

  useEffect(() => {
    setOptions(props.options);
    setCustomActions(props.customActions);
    setClickPosition(props.clickPosition);
    setId(props.id);
  }, [props.options, props.customActions, props.clickPosition, props.id]);

  return (
    <div className="contextual-menu-content hidden" id={id}>
      {/*if you want to render child props initially dont set renderChildLast or set renderChildLast to false*/}
      {!props.renderChildLast ? props.children : ''}
      {options.map((o, i) => {
        let loader = <div className="ui active inline loader mrlm tiny" />;
        //TODO: the fieldclass, need to discuss with BRYAN:SU
        if (!o.isFetching) loader = ''; //if it is not fetching
        let menuItem = '';
        if (o.renderAsChild) {
          //if you want to render a children in the middle of the menu
          menuItem = o.childComponent;
        } else {
          menuItem = (
            <div
              data-show={typeof o.show == 'boolean' ? o.show : true}
              data-opaque={typeof o.active == 'boolean' && !o.active ? true : false}
              onClick={typeof o.active == 'boolean' && !o.active ? null : o.action}
              key={i + (typeof o.title == 'string' ? o.title.toLowerCase().split(' ').join() : o.title)}
              className={o.fieldClass}
            >
              <i data-show={o.iconClassName} className={o.iconClassName} /> {o.title}
              {loader}
            </div>
          );
        }
        return menuItem;
      })}
      {/* //set renderChildLast as true if you want to rend children in start */}
      {props.renderChildLast ? props.children : ''}
    </div>
  );
}

let isHidden = function (el) {
  return el.offsetParent === null;
};
let isVisible = function (el) {
  return !isHidden(el);
};

// This function is to close the whole contextual menu when contextual menu is still open in unexpected senarios.
// e.g close the contexual menu after cliking its submenu tab to open a dialog.
function forceCloseContextualMenu(selector, cb, event) {
  if (cb) cb();

  window.$(selector).find('.row.active').toggleClass('active', false);
  window.$(selector).find('.contextual-menu-content').toggleClass('hidden', true);
}

function hideWhenClickAwayOrResize(selector, cb, event) {
  if (typeof cb != 'function') {
    event = cb;
    cb = null;
  }

  let parentRow = event.target;

  if (event.target.closest && parentRow.classList) {
    parentRow = event.target.closest('.row');

    if (
      parentRow &&
      parentRow.classList.contains('active') &&
      !!parentRow.querySelectorAll('.contextual-menu-content')
    ) {
      return;
    }
  }

  if (cb) cb();

  window.$(selector).find('.row.active').toggleClass('active', false);
  window.$(selector).find('.contextual-menu-content').toggleClass('hidden', true);
}

let showHideMenu = (that, selector, query, target, currentTarget, customOffsetTop, constrainedContainer) => {
  window.$(selector).find('.row.active').toggleClass('active', false);
  window.$(selector).find('.contextual-menu-content').toggleClass('hidden', true);

  if (!!that) {
    that.setCurrentActiveItem(
      window.$(target).parent().hasClass('row')
        ? window.$(target).parent()[0]
        : window.$(target).parent().parent().hasClass('column')
        ? window.$(target).parent().parent().parent()[0]
        : window.$(target).parent().parent()[0]
    );
    if (that && that._currentItem && that._currentItem.classList.contains('contextual-menu-content')) {
      return;
    }

    let elementToMoveAround = window.$(that.getCurrentActiveItem()).children('.contextual-menu-content');
    window.$(that.getCurrentActiveItem()).toggleClass('active');
    elementToMoveAround.toggleClass('hidden');
    //window.$(elementToMoveAround).find(".dropdown").toggleClass("active", false)

    if (
      window.$(selector + ':visible').height() + that.mouseY > window.$(window.top).height() &&
      !!window.$(elementToMoveAround).parent().position() &&
      window.$(elementToMoveAround).parent().position().top - window.$(elementToMoveAround).height() > 0
    ) {
      console.log('doesnt fit horizontally or vertically, so display horizontally');
      window.$(elementToMoveAround).toggleClass('reversed-contextual-menu', true); //menu doesnt fit horizontally and fits vertically
    } else {
      console.log('does fit horizontally');
      window.$(elementToMoveAround).toggleClass('reversed-contextual-menu', false);
    }
  } else {
    var currentItem = window.$(target).parent().hasClass('row')
      ? window.$(target).parent()[0]
      : window.$(target).parent().parent().hasClass('column')
      ? window.$(target).parent().parent().parent()[0]
      : window.$(target).parent().parent()[0];

    let elementToMoveAround = window.$(currentItem).children('.contextual-menu-content');
    // Get the DOM element from Jquery object
    let elementToRender = elementToMoveAround.get(0);
    // Handling exception check
    if (elementToRender == undefined) {
      if (!!currentTarget) {
        currentItem = window.$(currentTarget);
        elementToMoveAround = window.$(currentItem).children('.contextual-menu-content');
        elementToRender = elementToMoveAround.get(0);
      }
    }

    window.$(currentItem).toggleClass('active');
    elementToMoveAround.toggleClass('hidden');

    // If this is modern browser and it supports viewport relative position check
    // If it does not support this method, render it downward whatever
    if (typeof elementToRender.getBoundingClientRect == 'function' && !!elementToRender.getBoundingClientRect()) {
      // getBoundingClientRect() can get the element's position relative to viewport
      let elementToRenderHeight =
        elementToRender.getBoundingClientRect().bottom - elementToRender.getBoundingClientRect().top;
      // Get its parent
      let elementToRenderParent = elementToRender.parentElement;
      if (
        typeof elementToRenderParent.getBoundingClientRect == 'function' &&
        !!elementToRenderParent.getBoundingClientRect()
      ) {
        let viewportHight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        let elementToRenderParentHeight =
          elementToRenderParent.getBoundingClientRect().bottom - elementToRenderParent.getBoundingClientRect().top;

        let comparedTop = elementToRenderParent.getBoundingClientRect().top;

        if (constrainedContainer) {
          viewportHight = Math.min(viewportHight, constrainedContainer.getBoundingClientRect().bottom);
          if (constrainedContainer.getBoundingClientRect().top < 0) {
            // the container is out of the view
            comparedTop =
              Math.abs(constrainedContainer.getBoundingClientRect().top) +
              elementToRenderParent.getBoundingClientRect().top;
          }
        }
        let parentVisibleToBottom = viewportHight - elementToRenderParent.getBoundingClientRect().bottom;

        if (parentVisibleToBottom < elementToRenderHeight + 10 && elementToRenderHeight + 10 <= comparedTop) {
          if (!!customOffsetTop) {
            if (elementToRenderHeight + customOffsetTop <= comparedTop) {
              console.log('doesnt fit downwards');
              window.$(elementToMoveAround).toggleClass('reversed-contextual-menu', true); //menu doesnt fit horizontally and fits vertically
            } else {
              // Need to also check below is not enough space
              console.log('fit downwards');
              window.$(elementToMoveAround).toggleClass('reversed-contextual-menu', false);
            }
          } else {
            // Open menu downwards only when:
            // If visible bottom of window has not enough space, and top of window's visible part has enought space
            console.log('doesnt fit downwards');
            window.$(elementToMoveAround).toggleClass('reversed-contextual-menu', true); //menu doesnt fit horizontally and fits vertically
          }
        } else {
          // Need to also check below is not enough space
          console.log('fit downwards');
          window.$(elementToMoveAround).toggleClass('reversed-contextual-menu', false);
        }
      }
    } else {
      // if getBoundingClientRect() does not support on old browsers, then open menu downwards anyway
      // Need to also check below is not enough space
      console.log('fit downwards');
      window.$(elementToMoveAround).toggleClass('reversed-contextual-menu', false);
    }
  }
};

export { ContextualMenu, hideWhenClickAwayOrResize, forceCloseContextualMenu, showHideMenu };
